document.querySelector("#menu-toggle")?.addEventListener("click", function () {
    document.querySelector("nav ul").classList.toggle("max-h-0");
    document.querySelector("nav").classList.toggle("active");
});
